import { render, staticRenderFns } from "./DelayContainer.vue?vue&type=template&id=513bb14b"
import script from "./DelayContainer.vue?vue&type=script&lang=js"
export * from "./DelayContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports